import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './AdminLocations.css';

// Управление локациями и маршрутами в панели администратора
const AdminLocationsManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Проверка - есть ли в url подстрока '/routes'
  const isRoutesActive = location.pathname.includes('/routes');

  return (
    <div className="admin-locations-management">
      <div className="admin-locations-management_header">
        <h1 className="admin-locations-management_title">Управление локациями/маршрутами</h1>
        
        {/* Блок с двумя вкладками */}
        <div className="admin-locations-management_tabs">
        
          {/* Кнопка "Локации" - активна, если не активны маршруты */}
          <button 
            className={`admin-locations-management_tab ${!isRoutesActive ? 'active' : ''}`}
            onClick={() => navigate('/admin/locations/list')} 
          >
            Локации
          </button>
        
          {/* Вкладка "Маршруты" - активна, если в url есть '/routes' */}
          <button 
            className={`admin-locations-management_tab ${isRoutesActive ? 'active' : ''}`}
            onClick={() => navigate('/admin/locations/routes')} 
          >
            Маршруты
          </button>
        </div>
      </div>
      
      {/* Outlet - место, куда будут подставляться дочерние компоненты (например, список локаций или маршрутов) */}
      <div className="admin-locations-management_content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLocationsManagement;